import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CheckboxWithLabel } from "formik-mui";
import { Formik, Form } from "formik";
import { Field } from "formik";
import { Button, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import Skeleton from "../../../components/Skeleton/Skeleton";
import { useAdminSettings } from "../../../hooks/adminSettings";
import { useSnackbarNotifications } from "../../../hooks/snackbar";

const RolesPermissionsSettingsForm = ({
  submitForm,
  values,
  setFieldValue,
  errors,
  disabled,
  isLoading,
  isUpdating,
  allowValidate
}) => {
  const { t } = useTranslation();

  return (
    <Form>
      <Box display="flex" flexDirection="column" mb={1}>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          alignItems={{ xs: "stretch", md: "flex-start" }}
        >
          <Box display="flex" flexDirection="column" flex={1}>
            {allowValidate && (
              <Box mx={4}>
                <Skeleton loading={isLoading && !isUpdating} height={54}>
                  <Field
                    component={CheckboxWithLabel}
                    name="customRoleValidateEnableShopReview"
                    Label={{
                      label: (
                        <Typography variant="subtitle1">
                          {t(
                            "rolesPermissionsSettings.validateEnableMysteryShopLabel"
                          )}
                        </Typography>
                      )
                    }}
                    color="primary"
                    type="checkbox"
                  />
                  <Chip label={t("New")} color="primary" size="small" />
                </Skeleton>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" mt={4}>
        <Button
          variant="contained"
          color="primary"
          onClick={submitForm}
          disabled={disabled}
        >
          {t("rolesPermissionsSettings.saveSettings")}
        </Button>
      </Box>
    </Form>
  );
};

const RolesPermissionsSettings = () => {
  const { t } = useTranslation();

  const {
    isLoading,
    isSaving,
    getRolesPermissions,
    updateRolesPermissions
  } = useAdminSettings();

  const {
    displaySuccessMessage,
    displayErrorMessage
  } = useSnackbarNotifications();

  const [settingsData, setSettingsData] = useState();

  const allowValidate = useSelector(
    state => state.userState.user.permissions.allowValidate
  );

  useEffect(() => {
    const fetchRoles = async () => {
      const data = await getRolesPermissions();
      setSettingsData(data);
    };
    fetchRoles();
  }, []);

  const onSubmit = async values => {
    if (!allowValidate) delete values.customRoleValidateEnableShopReview;
    const response = await updateRolesPermissions(values);
    if (response.errors || response.error) {
      displayErrorMessage(t("rolesPermissionsSettings.errorMsg"));
    } else {
      setSettingsData(response);
      displaySuccessMessage(t("rolesPermissionsSettings.successMsg"));
    }
  };

  return (
    <Formik
      initialValues={{
        customRoleValidateEnableShopReview: settingsData
          ? settingsData.customRoleValidateEnableShopReview
          : false
      }}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ submitForm, values, errors, setFieldValue }) => (
        <RolesPermissionsSettingsForm
          submitForm={submitForm}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          disabled={isSaving || isLoading}
          isLoading={isLoading}
          isUpdating={isSaving}
          allowValidate={allowValidate}
        />
      )}
    </Formik>
  );
};

export default RolesPermissionsSettings;
